import BybVrSlider from "@Components/game/common/dialog/byb-vr-slider";
import { GameModeCard } from "@Components/game/game-mode";
import { usePractiseContext } from "@Context/game/practise/practise-context";
import { AnalyticsEvents } from "@Enums/index";
import { useAnalytics } from "@hooks/common/analytics/use-analytics";
import useI18n from "@i18n";
import { Stack, Typography } from "@mui/material";

const ScenarioCountConfig = () => {
  const { i18n } = useI18n();
  const { sessionOptions, setSessionOptions } = usePractiseContext();
  const { track } = useAnalytics();

  const handleScenarioCountChange = (event: Event, newValue: number | number[]) => {
    setSessionOptions({
      ...sessionOptions,
      scenario_count: newValue as number,
    });
    track(AnalyticsEvents.practice_settings_adjusted, { scenario_count: newValue });
  };

  return (
    <GameModeCard>
      <Stack spacing={1.5}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="text1xl500" color="dsNeutral.v300">
            {i18n("practice.scenarios")}
          </Typography>
          <Typography variant="text1xl500" color="dsBase.v200">
            {sessionOptions.scenario_count}
          </Typography>
        </Stack>
        <BybVrSlider value={sessionOptions.scenario_count} onChange={handleScenarioCountChange} min={1} max={30} step={1} />
      </Stack>
    </GameModeCard>
  );
};

export default ScenarioCountConfig;
